<button
  #innerButton
  [type]="typeBtn"
  [disabled]="disabled || loading"
  [ngClass]="finalClasses"
>
  <fa-icon
    *ngIf="loading"
    class="mr-2"
    [icon]="faSpinner"
    [animation]="'spin-pulse'"
  ></fa-icon>
  <ng-content></ng-content>
</button>